<template>
  <el-form ref="form" :model="form" label-width="auto">
    <div class="poster-box">
      <div class="logo-content">
        <img height="100%" src="../image/logo.png" alt="">
      </div>
      <div class="serve-content">
        <el-upload
          class="avatar-uploader"
          :action="uploadPath"
          :show-file-list="false"
          :headers="importHeaders"
          :on-progress="handelProgress"
          :on-error="handleAvatarError"
          :on-success="(res)=>handleAvatarSuccess(res, 'topUrl')"
          :before-upload="beforeImageUpload"
          accept=".jpg, .jpeg, .png, .webp, .gif, .bmp"
        >
          <img v-if="form.topUrl" :src="form.topUrl" width="100%">
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </div>
      <div class="tabs-content">
        <div class="tab-content">
          <div class="tab-content">
            <div class="tab-item tab-item-active">
              <div class="tab-item-text">企业信息</div>
            </div>
            <div class="tab-item">
              <div class="tab-item-text">种植溯源</div>
            </div>
            <div class="tab-item">
              <div class="tab-item-text">加工溯源</div>
            </div>
            <div class="tab-item">
              <div class="tab-item-text">仓储溯源</div>
            </div>
          </div>
        </div>
      </div>
      <div class="info-content">
          <div class="info-title">
            <div class="dot"></div>
          </div>
          <div class="info-box">
            <div class="info-item">
              <el-upload
                class="avatar-uploader"
                :action="uploadPath"
                :show-file-list="false"
                :headers="importHeaders"
                :on-progress="handelProgress"
                :on-error="handleAvatarError"
                :on-success="(res)=>handleAvatarSuccess(res, 'infoUrl')"
                :before-upload="beforeImageUpload"
                accept=".jpg, .jpeg, .png, .webp, .gif"
              >
                <img v-if="form.infoUrl" :src="form.infoUrl" width="100%">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </div>
          </div>
      </div>
    </div>
  </el-form>
</template>

<script>
import { uploadPath } from '@/api/system/system'
import { getSettingByKey, saveSettingByKey } from '@/api/system/manage'
export default {
  name: 'from',
  data() {
    return {
      loading: false,
      activeTab: 0,
      form:{
        topUrl: '',
        infoUrl: '',
      },
      traceabilityModelGroup: {
        id:'',
        groupIndex: 2,
        name: '客户溯源页面模板设置',
        code: 'customerTraceabilityTemplate',
        value: '',
        extra: ''
      },
    }
  },
  computed: {
    uploadPath() {
      return uploadPath()
    },
    importHeaders() {
      const token = sessionStorage.getItem('token')
      return { Authorization: 'Bearer ' + token }
    },
  },
  methods: {
    getData(code){
      getSettingByKey({code})
        .then((res) => {
          if (res.flag) {
            res.data.groupIndex = 2
            this.traceabilityModelGroup = Object.assign(this.traceabilityModelGroup, res.data)
            let traceabilityModelGroupImg = res.data.extra ? JSON.parse(res.data.extra) : {}
            this.form.topUrl = traceabilityModelGroupImg?.topUrl
            this.form.infoUrl = traceabilityModelGroupImg?.infoUrl
          } else {
            this.$message.error(res.message)
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    beforeImageUpload (file) {
      if(this.loading){
        this.$message.warning('有图片正在上传中，请等待...')
        return false
      }
      const fileSuffix = file.name.substring(file.name.lastIndexOf('.') + 1)
      let whiteList = ['jpg', 'png', 'jpeg', 'webp', 'gif', 'bmp']
      const isJPG = whiteList.indexOf(fileSuffix.toLowerCase()) > -1
      if (!isJPG) {
        this.$message.error('文件只能是 jpg/png/webp/gif/bmp 格式')
      }
      return isJPG
    },
    handelProgress() {
      this.loading = true
      this.$emit('on-upload', { fileUploading: true })
    },
    handleAvatarSuccess(res, fieldName) {
      this.loading = false
      this.form[fieldName] = res.data.url
      this.$message.success('上传成功！')
      this.$emit('on-upload', { fileUploading: false })
    },
    handleAvatarError() {
      this.loading = false
      this.$message.error('上传失败')
      this.$emit('on-upload', { fileUploading: false })
    },
    submit() {
      return new Promise(async (resolve, reject) => {
        if (!this.form.topUrl || !this.form.infoUrl) {
          this.$message.error('请上传图片')
          return reject()
        }
        this.traceabilityModelGroup.extra = JSON.stringify(this.form)
        let result = await saveSettingByKey(this.traceabilityModelGroup)
        if (result.code == 200 && result.flag) {
            this.$message.success(`提交成功`)
            resolve()
        } else {
          this.$message.error(result.message)
          reject()
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
.poster-box{
  width: 320px;
  height: 667px;
  padding: 0 15px;
  overflow-y: scroll;
  background-attachment: fixed;
  background: url('../image/bg.jpg') center no-repeat;
  background-size: cover;
  margin: auto;
  .logo-content{
    height: 46px;
    padding: 30px 15px;
  }
  .serve-content{
    width: 100%;
  }
  .contract-content{ 
    width: 100%;
    margin-top: 20px;
  }
  .tabs-content{
    margin-top: 20px;
    height: 52px;
    border-radius: 20px;
    background: rgba(255, 255, 255, 0.7);
    padding: 0 23px;
    .tab-content{
      width: 100%;
      height: 38px;
      margin: 7px 0;
      display: flex;
      justify-content: space-between;
      .tab-item{
        color: #393939;
        font-size: 12px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .tab-item-active{
          width: 85px;
          color: #000;
          border-radius: 50px;
          background: #fff;
          .tab-item-text{
            display: inline;
            position: relative;
            padding-bottom: 6px;
            font-weight: bold;
            &:after{
              content: '';
              width: 100%;
              height: 2px;
              background: #CB9A51;
              position: absolute;
              bottom: 0;
              left: 0;
            }
          }
      }
    }
  }
  .info-content{
    width: 100%;
    margin-bottom: 20px;
    .info-title{
      height: 33px;
      margin-top: 20px;
      border-radius: 10px;
      background-image: linear-gradient(to right, #CB9A51 2%, #EDE6D5 100%);
      display: flex;
      padding: 0 23px;
      align-items: center;
      font-weight: bold;
      font-size: 12px;
      .dot{
        width: 10px;
        height: 10px;
        border-radius: 100%;
        background: #EDE6D5;
        margin-right: 10px;
      }
    }
    .info-box{
      padding: 10px 30px;
      margin: 0 15px;
      max-height: 420px;
      background: #fff;
      overflow-y: scroll;
    }
    .info-item{
      padding: 12px 0;
    }
  }
  ::v-deep {
    .avatar-uploader .el-upload {
      border-radius: 20px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
      background: #fff;
      width: 100%;
    }
    .avatar-uploader .el-upload:hover {
      border-color: #c59429;
    }
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 100%;
      height: 178px;
      line-height: 178px;
      text-align: center;
    }
  }
}
</style>
